<template>
  <div class="trainer">
    <avatar-header :avatar="trainer.avatar" />
    <weui-group :notitle="true">
      <weui-button-cell>
        <uploader @input="onUploaded" />
      </weui-button-cell>
    </weui-group>
    <weui-group>
      <weui-cell label="姓名" :tips="trainer.name" :link="true" @click="changeName" />
      <weui-cell label="性别" :tips="formatGender(trainer.gender)" :link="true" @click="selectGender" />
    </weui-group>

    <weui-group v-if="coach">
      <weui-cell label="我的教练" :tips="coach.name" :link="{ name: ROUTE_COACH_HOME }" />
    </weui-group>
  </div>
</template>
<script>
import { createNamespacedHelpers } from 'vuex';
import weui from 'weui.js';
import { WeuiGroup, WeuiCell, WeuiButtonCell } from '@/components/weui';
import AvatarHeader from '@/components/AvatarHeader';
import Uploader from '@/components/trainer/Uploader';
import mixinUniqid from '@/mixins/uniqid';
import { PATCH_TRAINER } from '@/store/trainer/types';
import { GENDER_NONE, GENDER_MALE, GENDER_FEMALE } from '@/constants/types';
import { ROUTE_COACH_HOME } from '@/router/names';

const { mapState: mapTrainerState, mapActions: mapTrainerActions } = createNamespacedHelpers('trainer');
const { mapState: mapCoachState } = createNamespacedHelpers('coach');

export default {
    data() {
        return {
            ROUTE_COACH_HOME,
        };
    },
    computed: {
        ...mapTrainerState([
            'trainer',
        ]),
        ...mapCoachState([
            'coach',
        ]),
    },
    methods: {
        ...mapTrainerActions({
            patchTrainer: PATCH_TRAINER,
        }),
        formatGender(gender) {
            switch (gender) {
                case GENDER_MALE:
                    return '男';
                case GENDER_FEMALE:
                    return '女';
                case GENDER_NONE:
                default:
                    return '未设置';
            }
        },
        onUploaded(url) {
            this.trainer.avatar = url;
            this.patchTrainer({
                avatar: url,
            });
        },
        changeName() {

        },
        selectGender() {
            const vm = this;
            weui.picker([
                { label: '男', value: GENDER_MALE },
                { label: '女', value: GENDER_FEMALE },
            ], {
                id: this.uniqid(),
                defaultValue: [this.trainer.gender],
                onConfirm: (result) => {
                    vm.trainer.gender = result[0].value;
                    vm.patchTrainer({
                        gender: result[0].value,
                    });
                },
            });
        },
    },
    mixins: [
        mixinUniqid,
    ],
    components: {
        AvatarHeader,
        Uploader,
        WeuiGroup,
        WeuiCell,
        WeuiButtonCell,
    },
};
</script>



// WEBPACK FOOTER //
// src/containers/trainer/Home.vue